import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import App from '../../App';
import { REF_CURRENT_USER_ID, REF_KEYCLOAK_AUTH_TOKEN, REF_KEYCLOAK_REFRESH_TOKEN } from 'nexus-common/src/components/access/constants';
import {  getCurrentUserId } from 'nexus-common/src/components/access/AccessControl';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from "axios";
import { loginMessage, containerStyle } from './Login';

type UserInformation = {
    user_id?: number
    user_name?: string
    user_email?: string
  }
  
type DecodedToken = {
    email?: string
  }


const cookies = new Cookies();
export const Base: React.FC<{ user: any }> = ({ user }) => {
    const [currentUser, setCurrentUser] = useState<UserInformation | null | undefined>(user);
    const [baseUser, setBaseUser] = useState<UserInformation | null | undefined>(null);
    const [user_id, setUser_id] = useState<number | null>(null);
    const history = useNavigate();

    const updateUserInfo = (user_id:number, user_name:string, user_email: string) => {
        setCurrentUser( {user_id, user_name, user_email});
      }

    const getCurrentUserFromAPI = async () => {
        const token = cookies.get(REF_KEYCLOAK_AUTH_TOKEN);
        const user_info = currentUser || {};
        if(token) {
            try{
                if(user_info.user_id === undefined) {
                    const decoded:DecodedToken = jwtDecode(token);
                    const identifier =  decoded?.email;
                    if(identifier){
                        const user_email = identifier;
                        const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/users/${identifier}`);
                        const {id, first_name, last_name} = res.data;
                        if(id !== undefined && first_name !== undefined && last_name !== undefined) {
                            cookies.set(REF_CURRENT_USER_ID, id, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
                            updateUserInfo(id, `${first_name} ${last_name}`, user_email);
                            return {user_id: id, user_name:`${first_name} ${last_name}`, user_email: user_email};
                        } else {
                            // if user is in keycloak and not in nexus, user is taken to new user form.
                            cookies.set('scientia_url', `${window.location.href}`, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
                            window.location.href = process.env.REACT_APP_CREATE_USER_URL || window.location.href;
                            return null;
                        }
                    }
                }
            } catch(error) {
                console.error("Error fetching user data");
                return undefined;
            }
        }
        return undefined;             
    }

    const handleUserChange =  (): Promise<UserInformation | undefined | null> => {
        return  getCurrentUserFromAPI().then((loggedInUser: UserInformation | undefined | null) => {
            if (loggedInUser === null) {
            } else if (loggedInUser !== undefined && loggedInUser.user_id === getCurrentUserId()) {
                setBaseState(loggedInUser);
            } else {
                return getCurrentUserFromAPI().then((currentUser: UserInformation | undefined | null) => {
                    if (currentUser !== undefined){
                        setBaseState(currentUser);
                        return currentUser
                    }
                });
            }
            return loggedInUser as UserInformation | undefined;
        });
    };

    const logoutHandler = () => {
        // passing exact same attributes that were used to set the cookies to successfully delete the cookies.
        cookies.remove(REF_CURRENT_USER_ID, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
        cookies.remove(REF_KEYCLOAK_AUTH_TOKEN, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
        cookies.remove(REF_KEYCLOAK_REFRESH_TOKEN, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
        sessionStorage.removeItem("refreshUrl");

        setCurrentUser(null);
        history('/');
        window.location.href = process.env.REACT_APP_LOGOUT_URL || `https://www.emsl.pnnl.gov`;
    };

    const setBaseState = (baseUser: UserInformation | null) => {
        setCurrentUser(baseUser);
        setBaseUser(baseUser);
        setUser_id(getCurrentUserId());
    };

    // if user id in cookies, user info is updated.
    const curUserIdFromCookies = cookies.get(REF_CURRENT_USER_ID);
    if (curUserIdFromCookies !== undefined && curUserIdFromCookies !== null) {
        handleUserChange();
    }

    return (currentUser === undefined && curUserIdFromCookies !== undefined) ? (
        <div className={containerStyle}>
            <div className={loginMessage}>
                <h2>Logging you into Science Central™, please wait...</h2>
            </div>
        </div>
    ) : (
        <App
            key={JSON.stringify(currentUser)}
            currentUser={currentUser}
            handleUserChange={handleUserChange}
            logoutHandler={logoutHandler}
        />
    );
};

export default Base;
